import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, message, Row, Switch } from 'antd';
import React, { useState } from 'react';
import { instanceRef } from '../../../utils/axios';
import { cards } from '../CarUtil';

export default function Ampliacion(props) {
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState(cards);
  const [count, setCount] = useState(cards.length);
  const [marcadas, setMarcadas] = useState(false);
  const [complete, setComplete] = useState(true);

  const handleAdd = () => {
    if (complete) {
      setComplete(false);
      const countNew = count + 1 + props.cantampli;
      const newData = {
        item: countNew.toString(),
        key: countNew,
        parte: 'Edite el texto',
        checked: true
      };
      const dataSourceNew = [...dataSource, newData];
      setDataSource(dataSourceNew);
      setCount(countNew);
    } else {
      message.info(
        'Debe completar el nombre de la parte para poder añadir otra'
      );
    }
  };

  const edit = (checked, record) => {
    if (record.key > 18) {
      form.setFieldsValue({
        parte: '',
        comentario: '',
        checked,
        fotos: '',
        ...record
      });
    } else {
      const newData = [...dataSource];
      const row = newData.find((item) => record.key === item.key);
      row.check = checked;
      const index = newData.findIndex((item) => record.key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setDataSource(newData);
      } else {
        newData.push(row);
        setDataSource(newData);
      }
    }
  };

  const cancel = (key) => {
    setComplete(true);
    const newCount = key;
    const newData = dataSource.filter((item) => item.key !== key);
    for (let index = 17; index < newData.length; index += 1) {
      newData[index].key = index + 1 + props.cantampli;
    }
    setDataSource(newData);
    setCount(newCount - 1);
  };

  function onChange(checked, record) {
    edit(checked, record);
    checkMarcadas();
    if (record.key > 18) {
      cancel(record.key);
    }
  }

  function checkMarcadas() {
    const todasMarcadas = dataSource.filter((item) => item.check);
    if (todasMarcadas.length === dataSource.length) {
      setMarcadas(true);
    } else {
      setMarcadas(false);
    }
  }

  const save = async (text, key) => {
    setComplete(true);
    if (text) {
      try {
        const row = await form.validateFields();
        row.check = true;
        row.key = count;
        row.parte = text;
        const newData = [...dataSource];
        const index = newData.findIndex((item) => key === item.key);

        if (index > -1) {
          const item = newData[index];
          newData.splice(index, 1, { ...item, ...row });
          setDataSource(newData);
        } else {
          newData.push(row);
          setDataSource(newData);
        }
      } catch (errInfo) {
        // error
      }
    } else {
      cancel(key);
    }
  };

  const marcarTodas = () => {
    const dataSourceNew = [];
    dataSource.forEach((data) => {
      const dataNew = data;
      if (marcadas) {
        dataNew.check = false;
      } else {
        dataNew.check = true;
      }
      dataSourceNew.push(dataNew);
    });
    setDataSource(dataSourceNew);
    checkMarcadas();
  };

  const aceptar = () => {
    const dataNew = [];
    dataSource.forEach((data) => {
      if (data.check) {
        const dataAmpliacion = {
          key: data.key,
          parte: data.parte
        };
        dataNew.push(dataAmpliacion);
      }
    });
    crearAmpliacion(props.inspeccion.id, dataNew);
    updateEstado();
  };

  const updateEstado = async () => {
    props.creoampliacion();
  };

  const crearAmpliacion = async (inspeccionId, ampliacion) => {
    try {
      await instanceRef.instance.post(`ampliacion/create/`, {
        params: {
          inspeccionId,
          ampliacion,
          estado: 'Pendiente'
        }
      });
    } catch (error) {
      // error
    }
    return false;
  };

  return (
    <>
      <Card
        title="Partes del vehículo"
        extra={[
          <Switch
            checkedChildren="Desmarcar todas"
            unCheckedChildren="Marcar todas"
            onChange={() => marcarTodas()}
            type="primary"
            checked={marcadas}
          />
        ]}
      >
        <Row gutter={24}>
          {dataSource.map((record) => (
            <>
              <Col xs={24} md={8} sm={12} style={{ padding: 4 }}>
                {record.parte === 'Edite el texto' ? (
                  <>
                    <Switch
                      checked
                      onChange={(value) => {
                        onChange(value, record);
                      }}
                    />
                    <Input
                      placeholder="Parte del vehículo"
                      style={{ width: 'auto', marginLeft: 6 }}
                      onBlur={(e) => {
                        save(e.target.value, record.key);
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Switch
                      checked={record.check}
                      onChange={(value) => {
                        onChange(value, record);
                      }}
                    />
                    <span style={{ padding: 8 }}>{record.parte}</span>
                  </>
                )}
              </Col>
            </>
          ))}
          <Button
            icon={<PlusOutlined />}
            shape="circle"
            onClick={() => handleAdd()}
            type="primary"
            style={{ marginLeft: 4 }}
          />{' '}
          <span style={{ padding: 4 }}>Agregar otra parte de vehículo</span>
        </Row>
        <br />
        <Row gutter={24}>
          <Col xs={24} md={24} style={{ padding: 8, textAlign: 'center' }}>
            <Button onClick={() => aceptar()} type="primary">
              Solicitar Ampliación
            </Button>
          </Col>
        </Row>
      </Card>
    </>
  );
}
